import FormField from "components/shared/form/field";
import React from "react";

export default class Field extends FormField {
    render() {
        return (
            <>
                {this.renderField()}
                {this.renderError()}
            </>
        );
    }
}
